import React, {useEffect, useState} from "react";
import apiRequest from "../../services/apiRequest";
import {ChartBarIcon, ClipboardDocumentIcon, HomeModernIcon, TrophyIcon, UserIcon} from "@heroicons/react/24/outline";
import {
  VisibilityLevel,
  LkpLevelOptions,
  VisibilityType,
  InternalUser,
  PeriodType,
  CustomPeriod
} from "./Analytics.type";
import {IntlShape} from "react-intl";
import moment from "moment";
import {PRIVILEGED_ROLES} from "../../constants";

export const getSectionIcon = (section: string) => {
  switch (section) {
    case 'worksites':
      return HomeModernIcon
    case 'configurations':
      return ClipboardDocumentIcon
    case 'products':
      return ChartBarIcon
    case 'game':
      return TrophyIcon
    default:
      return UserIcon
  }
}

export const getVisibilityLevel = (roleType: string) => {
  if (PRIVILEGED_ROLES.includes(roleType)) {
    return 1
  }
  if (['field', 'sales_director'].includes(roleType)) {
    return 2
  }
  if (roleType === 'area_manager') {
    return 3
  }
  return 4
}

const lkpLevelOptions: LkpLevelOptions[] = [
  {name: "visibility_full", levels: [1, 2, 3]},
  {name: "visibility_field", levels: [1]},
  {name: "visibility_sales_director", levels: [1]},
  {name: "visibility_area_manager", levels: [1, 2]},
  {name: "visibility_agent", levels: [1, 2, 3]}
]

export const getVisibilityOptions = (visibilityLevel: VisibilityLevel, intl: IntlShape) => {

  const options = lkpLevelOptions.filter(i => i.levels.includes(visibilityLevel)).map(i => i.name)
  return options.map((i) => ({
    value: i,
    name: intl.formatMessage({id: i}),
  }))
}

export const useInternalUsers = (countryCode: string, permission: string) => {

  const [users, setUsers] = useState();

  useEffect(() => {
    const fetchInternalUsers = () => {
      apiRequest
        .get(`/users/internal?country=${countryCode}&user_id=${permission}`)
        .then((res: any) => {
          setUsers(res);
        })
        .catch((err) => {
          console.log("errore", err)
        })
    }
    if (!users) {
      fetchInternalUsers()
    }
  }, [countryCode]) // eslint-disable-line react-hooks/exhaustive-deps

  return users
}


export const getUsersOptions = (visibility: VisibilityType, internalUsers: InternalUser[] , intl: IntlShape) => {
  const filteredUsers = internalUsers
    .filter(i => i.role.name === visibility.replace('visibility_', ''))
    .map(i => ({value: i.id, label: `${i.lastname} ${i.firstname}`}))
    .sort((a, b) => a.label.localeCompare(b.label))
  return [{value: 0, label: intl.formatMessage({id: "all"})}, ...filteredUsers]
}


export const getAnalysisPeriod = (period: PeriodType, customPeriod: CustomPeriod) => {
  if (period === 'custom') {
    return {
      start: moment.utc(customPeriod.start).local().format('YYYY-MM-DD'),
      end: moment.utc(customPeriod.end).local().format('YYYY-MM-DD'),
    }
  }
  let today = new Date();
  let startDate = today.setMonth(today.getMonth() - 1);
  if (period === 'last_week') {
    let today = new Date();
    startDate = today.setDate(today.getDate() - 7)
  }
  if (period === 'last_year') {
    let today = new Date();
    startDate = today.setFullYear(today.getFullYear() - 1)
  }
  if (period === 'next_month') {
    let today = new Date();
    let startDate = today.setMonth(today.getMonth());
    let endDate = today.setMonth(today.getMonth() + 1);
    return {start: moment(startDate).format('YYYY-MM-DD'), end: moment(endDate).format('YYYY-MM-DD')}
  }
  if (period === 'next_year') {
    let today = new Date();
    let startDate = today.setFullYear(today.getFullYear());
    let endDate = today.setFullYear(today.getFullYear() + 1);
    return {start: moment(startDate).format('YYYY-MM-DD'), end: moment(endDate).format('YYYY-MM-DD')}
  }
  return {start: moment(startDate).format('YYYY-MM-DD'), end: moment(new Date()).format('YYYY-MM-DD')}
}

export const getPeriodOptions = (tabIndex:number) => {
  // resales needs data in the future
  if (tabIndex === 4) {
    return [
      'next_month',
      'next_year',
      'custom'
    ]
  } else {
    return [
      'last_week',
      'last_month',
      'last_year',
      'custom'
    ]
  }
}